import type { CSSProperties } from 'react'
import { Toaster as Sonner } from 'sonner'

// Same bottom-right Sonner pattern as sibling flio OS; use this app's tokens.
export function Toaster() {
  return (
    <Sonner
      position="bottom-right"
      closeButton
      duration={4500}
      style={
        {
          '--normal-bg': 'var(--color-surface-raised)',
          '--normal-text': 'var(--color-text)',
          '--normal-border': 'var(--color-border)',
        } as CSSProperties
      }
    />
  )
}
